import { Decree } from "types/decree.type";
import { useDecree } from "../hooks/use-decree";
import { DecreeListing } from "./decree-listing";

interface DecreeListingPanelProps {
  selectedDecree?: string;
  onSelectDecree: (input: Decree) => void;
}

export const DecreeListingPanel = ({ selectedDecree, onSelectDecree }: DecreeListingPanelProps) => {
  const { setDecreeParams, decreeParams, decreeData, isLoading, refetchDecree } = useDecree();

  return (
    <DecreeListing
      decreeList={decreeData}
      selectedDecree={selectedDecree}
      onSelectDecree={onSelectDecree}
      isLoading={isLoading}
      decreesParams={decreeParams}
      setDecreeParams={setDecreeParams}
      refetchDecree={refetchDecree}
    />
  );
};
